import { rest } from 'msw'
import mockAccounts from '../../../__mocks__/Accounts/accounts.json'

const getVerificationRequestStatus = rest.get(
  `${API_URL}/api/business/account/verification-request-status`,
  async (req, res, ctx) => {
    return res(ctx.text('businessVerified'))
  }
)

const getUserAccounts = rest.get(`${API_URL}/api/account/user-accounts`, async (req, res, ctx) => {
  return res(ctx.json(mockAccounts))
})

const postAccountUser = rest.post(`${API_URL}/api/account/user`, async (req, res, ctx) => {
  return res(ctx.status(201))
})

const deleteAccountUser = rest.delete(`${API_URL}/api/account/user/:id`, async (req, res, ctx) => {
  return res(
    ctx.status(200),
    ctx.json({
      message: 'Success',
    })
  )
})

export default [getVerificationRequestStatus, getUserAccounts, postAccountUser, deleteAccountUser]
